"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _calculateStepInterval = _interopRequireDefault(require("./calculateStepInterval"));
var _showOffHelper = _interopRequireWildcard(require("./show-off-helper"));
var _mv2Rn = _interopRequireDefault(require("../../rn-bridge/mv2-rn"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import { martyConnector } from "../../redux/store";
class Movement {
  // we want to add delay only the first time the movement is executed
  constructor(name, iconName, rawSpeed, options) {
    // private rawSpeed: number;
    _defineProperty(this, "DANCE_DELAY", 500);
    _defineProperty(this, "DANCE_PENALTY_LIMIT", 2000);
    _defineProperty(this, "TURNS_PENALTY_LIMIT", 1500);
    _defineProperty(this, "KICK_DELAY_FACTOR", 1.55);
    _defineProperty(this, "GET_READY_PENALTY_LIMIT", 1500);
    _defineProperty(this, "hasDelayedBeenAdded", false);
    this.name = name;
    this.iconName = iconName;
    this.options = options;
    this.moveInMs = (0, _calculateStepInterval.default)(rawSpeed); // this is the timeout of the promise
    this.moveSpeed = (0, _calculateStepInterval.default)(rawSpeed); // this is the speed that is sent to marty
    this.moveSpeedLabel = rawSpeed / 0.7 < 0.33 ? "slow" : rawSpeed / 0.7 > 0.67 ? "fast" : undefined;
  }
  addDelay() {
    if (this.hasDelayedBeenAdded) return;
    switch (this.name) {
      case "dance":
      case "showOff":
        if (this.moveSpeed < this.DANCE_PENALTY_LIMIT) {
          this.moveSpeed = this.DANCE_PENALTY_LIMIT;
          this.moveInMs = this.DANCE_PENALTY_LIMIT;
        }
        this.moveInMs += this.DANCE_DELAY;
        break;
      case "getReady":
        if (this.moveSpeed < this.GET_READY_PENALTY_LIMIT) {
          this.moveSpeed = this.GET_READY_PENALTY_LIMIT;
          this.moveInMs = this.GET_READY_PENALTY_LIMIT;
        }
        break;
      case "kick":
        this.moveInMs *= this.KICK_DELAY_FACTOR;
        break;
      case "step":
        if (this.moveSpeed < this.TURNS_PENALTY_LIMIT) {
          this.moveSpeed = this.TURNS_PENALTY_LIMIT;
          this.moveInMs = this.TURNS_PENALTY_LIMIT;
        }
        break;
      default:
        break;
    }
    this.hasDelayedBeenAdded = true;
  }
  changeStepLength() {
    if (this.name !== "step" || this.moveSpeedLabel !== "fast") return;
    // for fast steps, we decrease steplength from 25/-25 to 20/-20
    if (this.options.stepLength < 0) {
      this.options.stepLength = -20;
    } else if (this.options.stepLength > 0) {
      this.options.stepLength = 20;
    }
  }
  execute(onEnd) {
    this.addDelay();
    this.changeStepLength();
    if (this.name === "showOff") {
      // show-off is a special case. It's not just a movement,
      // it's rather multiple movements send as one sequencer movement
      const danceMoveSpeed = 3800;
      const timesOfDancing = (0, _showOffHelper.default)(danceMoveSpeed);
      this.timeout = setTimeout(() => {
        onEnd();
        (0, _showOffHelper.discoChangeBlockPattern)("off");
        this.destroyTimeout();
      }, danceMoveSpeed * timesOfDancing + 800);
    } else {
      const trajectoryMessage = {
        type: "trajectory",
        payload: {
          name: this.name,
          options: _objectSpread({
            moveTime: this.moveSpeed
          }, this.options)
        }
      };
      let optionsString = '';
      const options = trajectoryMessage.payload.options;
      if (options) {
        for (const key in options) {
          optionsString += "".concat(key, "=").concat(options[key], "&");
        }
        optionsString = optionsString.slice(0, -1);
      }
      let cmd = "traj/".concat(this.name, "?").concat(optionsString);
      _mv2Rn.default.send_REST(cmd);
      this.timeout = setTimeout(() => {
        onEnd();
        this.destroyTimeout();
      }, this.moveInMs);
    }
  }
  destroyTimeout() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }
}
exports.default = Movement;